module.exports = __webpack_public_path__ + "static/brilliant-hero-7783ed50e95c2efc037e0cf722fd764d.jpg";